import React from 'react';
import { AuditProvider } from './AuditContext';
import AuditPage from './AuditPage';
import { AuditPageProps } from './types';

/**
 * Container component for the audit document request system.
 * Wraps the page content with the context provider.
 */
const AuditContainer: React.FC<AuditPageProps> = props => {
  return (
    <AuditProvider>
      <AuditPage {...props} />
    </AuditProvider>
  );
};

export default AuditContainer;
